import { Typography } from "@circle-react-uikit/Typography";
import { formatFileSize } from "@circle-react/helpers/fileSizeHelpers";

import { FileTypeIcon } from "./FileTypeIcon";
import type { Attachment } from "./types";

export const AttachmentDetails = ({
  attachment,
}: {
  attachment: Attachment;
}) => (
  <div className="flex w-full items-center space-x-2">
    <div className="mb-1 flex items-center">
      <FileTypeIcon content_type={attachment.content_type} />
    </div>
    <div className="flex flex-col truncate">
      <div className="truncate text-left">
        <Typography.LabelSm weight="semibold">
          {attachment.filename}
        </Typography.LabelSm>
      </div>
      <div className="text-left">
        <Typography.LabelXs weight="regular">
          {formatFileSize(attachment.byte_size)}
        </Typography.LabelXs>
      </div>
    </div>
  </div>
);
